import React from "react";

interface CheckboxProps {
  label: React.ReactNode;
  checked: boolean;
  onChange: (checked: boolean) => void;
  className?: string;
  disabled?: boolean; // Optional prop for disabling the checkbox
}

const Checkbox: React.FC<CheckboxProps> = ({
  label,
  checked,
  onChange,
  className = "",
  disabled = false, // Default value for retro compatibility
}) => {
  return (
    <label className={`checkbox ${className}`}>
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        disabled={disabled} // Use the disabled prop
      />
      <span>{label}</span>
    </label>
  );
};

export default Checkbox;
